import { Controller } from "@hotwired/stimulus"
import QrScanner from "qr-scanner"

// Kamera-Scanner für QR-Codes (Lib: qr-scanner). Gibt jeden Treffer als Event "qr-scanner:result" weiter.
// Braucht einen Secure Context (https oder localhost), sonst gibt es keinen Kamerazugriff.
//
// Connects to data-controller="qr-scanner"
export default class extends Controller {
  static targets = ["video", "noCameraContainer", "videoContainer", "spinner"]
  static values = {
    preferredCamera: { type: String, default: "environment" }, // Rückkamera bevorzugen
    highlightScanRegion: { type: Boolean, default: true },
  }

  connect() {
    // Kamera freigeben, wenn die Seite unsichtbar wird (Sheet zugeklappt, App im Hintergrund), und danach neu starten.
    // Ohne das bleibt der Stream hängen und der nächste Start scheitert.
    this.onVisibilityChange = () => (document.visibilityState === "hidden" ? this.stop() : this.restart())
    document.addEventListener("visibilitychange", this.onVisibilityChange)

    this.replaceVideoWithFreshClone()
    this.qrScanner = new QrScanner(this.videoTarget, (result) => this.dispatch("result", { detail: { content: result } }), {
      preferredCamera: this.preferredCameraValue,
      highlightScanRegion: this.highlightScanRegionValue,
      highlightCodeOutline: true,
    })

    // "both": auch helle Codes auf dunklem Hintergrund erkennen
    this.qrScanner.setInversionMode("both")
  }

  disconnect() {
    document.removeEventListener("visibilitychange", this.onVisibilityChange)
    this.qrScanner.destroy()
  }

  async start() {
    this.active = true
    try {
      await this.qrScanner.start()
      this.showVideoFeed()
    } catch (error) {
      this.showNoCameraContainer()
    } finally {
      this.hideSpinner()
    }
  }

  stop() {
    this.active = false
    this.qrScanner.stop()
  }

  // Nach dem Sichtbarwerden nur weiterlaufen, wenn der Scanner nicht bewusst gestoppt wurde (z.B. nach erfolgreichem Scan).
  restart() {
    if (this.stoppedByUser) return

    this.start()
  }

  stopScanning() {
    this.stoppedByUser = true
    this.stop()
  }

  // iOS 27 bugfix. iOS 27 zeigt den Kamera-Stream nicht in <video>-Elementen, die Turbo per DOMParser + adoptNode eingefügt hat.
  // Deswegen das <video> hier händisch klonen.
  replaceVideoWithFreshClone() {
    this.videoTarget.replaceWith(this.videoTarget.cloneNode(true))
  }

  showNoCameraContainer() {
    this.noCameraContainerTarget.classList.remove("d-none")
    this.videoContainerTarget.classList.add("d-none")
  }

  showVideoFeed() {
    this.noCameraContainerTarget.classList.add("d-none")
    this.videoContainerTarget.classList.remove("d-none")
  }

  hideSpinner() {
    if (this.hasSpinnerTarget) this.spinnerTarget.classList.add("d-none")
  }
}
